import {
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    createElementVNode as _$ce,
} from 'intact';
import {Transfer, Table, TableColumn, Input, Icon} from 'kpc';

var _$tmp0 = {
    'className': 'k-icon-search',
    'size': 'small'
};
var _$tmp1 = {
    'className': 'k-icon-search',
    'size': 'small'
};
var _$tmp2 = {
    'key': 'name',
    'title': '名称'
};
var _$tmp3 = {
    'key': 'ip',
    'title': 'IP地址'
};
var _$tmp4 = {
    'key': 'status',
    'title': '状态'
};
var _$tmp5 = {
    'key': 'name',
    'title': '名称'
};
var _$tmp6 = {
    'key': 'ip',
    'title': 'IP地址'
};
var _$tmp7 = {
    'key': 'status',
    'title': '状态'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    var _$refs = this.refs;
    var _$ref_leftTable = function(i) {_$refs['leftTable'] = i};
    var _$ref_rightTable = function(i) {_$refs['rightTable'] = i};
    
    return _$cc(Transfer, {
        'filterable': true,
        'enableAdd': this.enableAdd,
        'enableRemove': this.enableRemove,
        'ev-add': this.onAdd,
        'ev-remove': this.onRemove,
        'className': 'custom-table-transfer',
        '$blocks': function($blocks) {
            var _$blocks = {}, __$blocks = _$ex({}, $blocks);
            return (
                (
                    (_$blocks['header'] = function($super, type) {
                        return (
                            (type === 'left') ?
                                _$ce(2, 'div', [
                                    _$ce(2, 'span', '可选数据', 16),
                                    _$ce(2, 'span', this.get('leftCheckedKeys').length + ' / ' + this.get('leftData').length, 0)
                                ], 4) :
                                _$ce(2, 'div', [
                                    _$ce(2, 'span', '已选数据', 16),
                                    _$ce(2, 'span', this.get('rightCheckedKeys').length + ' / ' + this.get('rightData').length, 0)
                                ], 4)
                        );
                    }),
                    (__$blocks['header'] = function($super, data) {
                        var block = $blocks['header'];
                        var callBlock = function() {
                            return _$blocks['header'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                (
                    (_$blocks['filter'] = function($super, type) {
                        return (
                            (type === 'left') ?
                                _$cc(Input, {
                                    'placeholder': '搜索名称、IP或状态',
                                    'clearable': true,
                                    'size': 'small',
                                    'value': this.get('leftKeywords'),
                                    'ev-$change:value': this.onLeftKeywordsChange,
                                    '$blocks': function($blocks) {
                                        var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                                        return (
                                            (
                                                (_$blocks['prefix'] = function($super) {
                                                    return (
                                                        _$cc(Icon, _$tmp0)
                                                    );
                                                }),
                                                (__$blocks['prefix'] = function($super, data) {
                                                    var block = $blocks['prefix'];
                                                    var callBlock = function() {
                                                        return _$blocks['prefix'].call($this, $super, data);
                                                    };
                                                    return block ?
                                                        block.call($this, callBlock, data) :
                                                        callBlock();
                                                })
                                            ),
                                            __$blocks
                                        );
                                    }.call($this, _$em)
                                }) :
                                _$cc(Input, {
                                    'placeholder': '搜索名称、IP或状态',
                                    'clearable': true,
                                    'size': 'small',
                                    'value': this.get('rightKeywords'),
                                    'ev-$change:value': this.onRightKeywordsChange,
                                    '$blocks': function($blocks) {
                                        var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                                        return (
                                            (
                                                (_$blocks['prefix'] = function($super) {
                                                    return (
                                                        _$cc(Icon, _$tmp1)
                                                    );
                                                }),
                                                (__$blocks['prefix'] = function($super, data) {
                                                    var block = $blocks['prefix'];
                                                    var callBlock = function() {
                                                        return _$blocks['prefix'].call($this, $super, data);
                                                    };
                                                    return block ?
                                                        block.call($this, callBlock, data) :
                                                        callBlock();
                                                })
                                            ),
                                            __$blocks
                                        );
                                    }.call($this, _$em)
                                })
                        );
                    }),
                    (__$blocks['filter'] = function($super, data) {
                        var block = $blocks['filter'];
                        var callBlock = function() {
                            return _$blocks['filter'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                (
                    (_$blocks['list'] = function($super, type) {
                        return (
                            (type === 'left') ?
                                _$cc(Table, {
                                    'data': this.get('leftFilteredData'),
                                    'rowKey': item => item.id,
                                    'checkedKeys': this.get('leftCheckedKeys'),
                                    'ev-$change:checkedKeys': this.onLeftCheckedKeysChange,
                                    'pagination': {limit: 5, showLimits: false, showTotal: false},
                                    'ref': _$ref_leftTable,
                                    'fixHeader': true,
                                    'children': [
                                        _$cc(TableColumn, _$tmp2, 'name'),
                                        _$cc(TableColumn, _$tmp3, 'ip'),
                                        _$cc(TableColumn, _$tmp4, 'status')
                                    ]
                                }, null, _$ref_leftTable) :
                                _$cc(Table, {
                                    'data': this.get('rightFilteredData'),
                                    'rowKey': item => item.id,
                                    'checkedKeys': this.get('rightCheckedKeys'),
                                    'ev-$change:checkedKeys': this.onRightCheckedKeysChange,
                                    'pagination': {limit: 5, showLimits: false, showTotal: false},
                                    'ref': _$ref_rightTable,
                                    'fixHeader': true,
                                    'children': [
                                        _$cc(TableColumn, _$tmp5, 'name'),
                                        _$cc(TableColumn, _$tmp6, 'ip'),
                                        _$cc(TableColumn, _$tmp7, 'status')
                                    ]
                                }, null, _$ref_rightTable)
                        );
                    }),
                    (__$blocks['list'] = function($super, data) {
                        var block = $blocks['list'];
                        var callBlock = function() {
                            return _$blocks['list'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                __$blocks
            );
        }.call($this, _$em)
    });
};